import './App.css';
import './css/bootstrap/bootstrap.min.css';
import './css/flexslider/flexslider.css';
import './css/animate/animate.css';
import './css/countdown/jquery.countdown.css';
import './css/magnific-popup/magnific-popup.css';
import './css/owlcarousel/owl.carousel.css';
import './css/owlcarousel/owl.theme.css';
import './css/fonts/fontello/css/fontello.css';
import './css/style.css';

import * as React from 'react';

import { HomeScreen } from './screens/HomeScreen';

// import './css/preloader.css';
// import './css/preloader-default.css';

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <HomeScreen />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx